import { api } from '../../api-helper';
import { URLS } from '../../../constants/URLS';

export const IMPERSONATION_USER_TYPES = {
  INTERNAL: 'internal',
  CLIENT: 'client'
};

export const getImpersonationUsers = ({
  userType,
  query,
  partnerProfileId,
  limit = 15
}) => {
  return api.get(URLS.impersonationUsers, {
    params: {
      userType,
      limit,
      ...(query && { query }),
      ...(partnerProfileId && { partnerProfileId })
    },
    headers: {
      needsToken: true
    }
  });
};

// Responds like login: { user, token, refreshToken, impersonating: true }
export const impersonateUser = (userID) => {
  return api.post(
    URLS.impersonation,
    { userID },
    {
      headers: {
        needsToken: true
      }
    }
  );
};

// Responds with the admin's session: { user, token, refreshToken, impersonating: false }
export const stopImpersonatingUser = () => {
  return api.delete(URLS.impersonation, {
    headers: {
      needsToken: true
    }
  });
};
